import { useNavigate } from 'react-router-dom'
import { Button, HStack } from '@chakra-ui/react'

import { CardContainer } from 'components/CustomCard'
import { AddIcon } from 'components/SVGS'

const BuyWicar = () => {
  const navigate = useNavigate()

  return (
    <CardContainer paddingY={4}>
      <HStack
        gap={4}
        flexDirection={{ base: 'column' , xl:'row' }}
        justifyContent="center"
        alignItems="center"
        w="full"
         >
        <Button
          onClick={() => navigate('/add-vehicle')}
          leftIcon={<AddIcon size={7} />}
          variant={'secondary'}
          w={{ base: 'full', md: 'xs' }}>
          Agregar vehículo
        </Button>
        <Button
          onClick={() => navigate('/new-subscription')}
          leftIcon={<AddIcon size={7} />}
          variant={'secondary'}
          w={{ base: 'full', md: 'xs' }}>
          Contratar
        </Button>
      </HStack>
    </CardContainer>
  )
}

export default BuyWicar
